module.exports = __webpack_public_path__ + "prod/1.42.2/img/pre_high_img6.fa11eb6b.png";